import http from "@/utils/http";

export function GetTempList() {
  return http({
    method: "GEt",
    url: "/feign/sns/system/open-screen-url",
  });
}
